import React from 'react';
import { Box, Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { PersonalInfoItemProps } from './types';

const PersonalInfoItem: React.FC<PersonalInfoItemProps> = ({ icon, value, tooltip }) => {
  let iconElement = null;

  if (icon) {
    iconElement = tooltip ? <Tooltip title={tooltip}>{icon}</Tooltip> : icon;
  }

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {iconElement}
      {typeof value === 'string' ? <Typography variant="body1">{value}</Typography> : value}
    </Box>
  );
};

export default PersonalInfoItem;
